<template>
  <div class="ticket-list-page">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Ticket List</div>
      </q-card-section>
      <q-separator />
      <q-card-section class="card-content">
        <div class="ticket-search">
          <q-input
            v-model="ticketNum"
            debounce="1000"
            outlined
            rounded
            input-style="font-size:12px"
            color="orange"
            placeholder="Search By Ticket Number"
            hint-color="white"
            dense
            dark
            @update:model-value="getTicket()"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
        <div class="ticket-search-select">
          <q-select
            rounded
            outlined
            v-model="type"
            label="Ticket Type"
            :options="types"
            color="orange"
            label-color="white"
            outline-color="white"
            input-style="font-size: 12px"
            dense
            dark
            input-class="font-color: white"
            @update:model-value="getTicket()"
          />
        </div>

      </q-card-section>
      <div class="ticket-list-table">
        <q-table
          bordered
          :rows="tableData"
          :columns="columns"
          row-key="ID"
          separator="cell"
          dark
          :loading="loading"
          rows-per-page-options="0"
          @row-click="onRowClick"
          :wrap-cells="true"
        >
          <template v-slot:[computedbodycellname]="props">
            <q-td :props="props">
              <div v-if="columnSelection === 'remarks'" class="my-table-details">
                <p v-html="props.value"></p>
              </div>
            </q-td>
          </template>
        </q-table>
        <div class="q-pa-lg flex flex-center pagination">
          <q-pagination
            v-model="pagination.current"
            :max="pagination.last"
            direction-links
            outline
            color="orange"
            active-design="unelevated"
            active-color="brown"
            active-text-color="orange"
            @update:model-value="getTicket()"
            :max-pages="3"
          />
        </div>
      </div>
    </q-card>
    <q-dialog
      v-model="donationModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 400px">
        <q-card-section>
          <div class="text-h6">Checking Ticket# {{ ticketDetails.TicketNumber }}</div>
        </q-card-section>

        <q-card-section class="q-pt-none" v-if="ticketDetails.Type === 'Donation'">
          <p>Reference Number : <strong>{{ ticketDetails.ReferenceNumber }}</strong></p>
          <p>Amount : <strong>{{ ticketDetails.Amount }}</strong></p>

          <q-input
            v-if="ticketDetails.Status === 'OPEN'"
            v-model="epBonus"
            outlined
            rounded
            input-style="font-size:12px"
            color="orange"
            hint="Bonus EP"
            dense
          />
        </q-card-section>

        <q-card-section class="q-pt-none" v-else>
          <p>Title: <strong>{{ ticketDetails.Title }}</strong></p>
          <p>Description: <strong>{{ ticketDetails.Description }}</strong></p>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <p>Request By: <strong>{{ ticketDetails.user_info.UserID }}</strong></p>
          <a :href="ticketDetails.ProofImage" target="_blank">Click here to See Proof</a>
        </q-card-section>

        
        <q-card-section class="q-pt-none">
          <q-input
            v-model="remarks"
            outlined
            rounded
            input-style="font-size:12px"
            color="orange"
            placeholder="Remarks"
            dense
            type="textarea"
          />
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal" v-if="ticketDetails.Status === 'OPEN'">
          <q-btn 
            style="background-color:green; color: black"
            flat
            label="Process"
            @click="process('process')"
           />
           <q-btn 
            style="background-color: #ff6b08; color: black"
            flat
            label="Reject"
            v-if="ticketDetails.Type === 'Donation'"
            @click="process('reject')"
           />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TicketList',
  computed: {
    ...mapGetters({
      user: 'user/getUser'
    }),
    dateToday () {
      return moment(new Date()).format('DD MMMM YYYY hh:mm:ss A')
    },
    computedbodycellname () {
      return 'body-cell-' + this.columnSelection     
    }
  },
  data () {
    return {
      separator: { label: 'Cell', value: 'cell' },
      columnSelection: 'remarks',
      columns : [
        {
          name: 'ID',
          align: 'center',
          label: 'ID',
          field: 'ID'
        },
        {
          name: 'TicketNumber',
          align: 'center',
          label: 'Ticket #',
          field: 'TicketNumber'
        },
        {
          name: 'remarks',
          align: 'center',
          label: 'Remarks',
          field: 'Remarks'
        },
        {
          name: 'Type',
          align: 'center',
          label: 'Ticket Type',
          field: 'Type'
        },
        {
          name: 'Amount',
          align: 'center',
          label: 'Amount',
          field: 'Amount',
          value: (value) => value ? value : '-'
        },
        {
          name: 'CreatedAt',
          align: 'center',
          label: 'Date Created',
          field: 'CreatedAt'
        },
        {
          name: 'UpdatedAt',
          align: 'center',
          label: 'Date Updated',
          field: 'UpdatedAt'
        },
        {
          name: 'processor',
          align: 'center',
          label: 'Processed By',
          field: 'processor'
        },
        {
          name: 'Status',
          align: 'center',
          label: 'Status',
          field: 'Status'
        }
      ],
      tableData: [],
      totalSpent: 0,
      loading: true,
      pagination: {
        current: 1,
        last: 1
      },
      ticketNum: '',
      type: null,
      types: ['Bug', 'Suggestions', 'Donation'],
      donationModal: false,
      ticketNumber: '',
      epBonus: 0,
      ticketDetails: null,
      remarks: null
    }
  },
  mounted () {
    this.$q.loading.show()

    this.getTicket()

    this.$q.loading.hide()
  },
  methods: {
    ...mapActions({
      getTickets: 'user/getTickets',
      getTicketById: 'user/getTicketById',
      processTicket: 'user/processTicket'
    }),
    async onRowClick (evt, row) {
      if (Number(this.user.UserType) >= 30) {
        this.$q.loading.show()

        await this.recaptchaLoad('requestticket')

        await this.getTicketById(row.ID)
          .then(response => {
            this.ticketDetails = response.data.data

            this.recaptchaLoad('requestticket')

            this.donationModal = true

            this.$q.loading.hide()
          })
          .catch(error => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative',
            })
 
            this.$q.loading.hide()
          })
      }
    },
    async process(type) {
      const parameter = {
        ticketId: this.ticketDetails.ID,
        bonus: this.epBonus,
        processType: type,
        remarks: this.remarks
      }

      this.$q.loading.show()

      await this.recaptchaLoad('processticket')

      await this.processTicket(parameter)
        .then(response => {
          this.recaptchaLoad('processticket')

          this.donationModal = false;

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })
          
          this.$q.loading.hide()
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    },
    async getTicket () {
    this.loading = true
      this.tableData = []
      
      const parameter = {
        params: {
          page: this.pagination.current,
          ticketNum: this.ticketNum,
          type: this.type
        }
      }

      await this.recaptchaLoad('requesttickets')

      await this.getTickets(parameter)
        .then(response => {
          this.recaptchaLoad('requesttickets')
          const { current_page, last_page, data } = response.data.data
          
          let modifiedData = data.filter((ticket) => {
            ticket.processor = ticket.processor ? ticket.processor.UserID : '-'

            return ticket
          })

          this.tableData = modifiedData
          
          this.pagination.current = current_page
          this.pagination.last = last_page

          this.loading = false
        })
        .catch(error => {
          this.loading = false

          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })
    }
  }
}
</script>

<style lang="scss">
.ticket-list-page {
  
  .my-card {
    background-color: $backgroundHeader;

    .ticket-list-table {
      background-color: $background;
      padding: 8px;
    }
  }

  .card-section {
    color: white;
  }

  .card-content {
    background-color: $background;
    color: white;
    gap: 16px;

    .ticket-search {
      margin-bottom: 16px;
    }

    .ticket-search-select {
      margin-bottom: 16px;
    }
  }
}
</style>